// extracted by mini-css-extract-plugin
export default {"root":"kjxAh","menu":"_2xhm0"};